import type { SxProps, Theme } from '@mui/material/styles';

import { CardView } from '@/components/Hcp/HcpCard/HcpCard';

type CustomSx = {
	root?: SxProps<Theme>;
	content?: SxProps<Theme>;
	name?: SxProps<Theme>;
};

export const getProfileCardSx = (
	view: CardView | undefined,
	customSx: CustomSx | undefined
) => ({
	name: [
		{ fontWeight: 'unset' },
		view === 'compact' && {
			maxWidth: 'calc(100% + 4px)',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			padding: '0 2px',
			margin: '0 -2px'
		},
		customSx?.name ?? false
	] as SxProps<Theme>,
	content: [
		{ gap: 0 },
		view === 'basic' && {
			textAlign: 'center'
		},
		view === 'compact' && {
			maxWidth: 'calc(100% - 40px - (2 * var(--mui-spacing)))'
		},
		customSx?.content ?? false
	] as SxProps<Theme>,
	root: [
		{
			'&:hover': {
				backgroundColor: 'unset'
			}
		},
		view === 'basic' && {
			flexDirection: 'column',
			padding: 1,
			borderRadius: 1
		},
		customSx?.root ?? false
	] as SxProps<Theme>
});
